import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { contentContext } from "../../context/contentContext";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import { canTakePaidBookings, paidBookingsPaused } from "../stripe/paidBookings";
import SessionPopup from "../../pages/SessionPopup";
import LocationSearch from "../LocationSearch";
import { ToastContainer, toast } from 'react-toastify';
import Loader from "../../components/loader";
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-bootstrap/Modal';
//  import { withGoogleMap, GoogleMap, withScriptjs} from "react-google-maps";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SpotsManageCore from "../Spots/SpotsManageCore";
import { keyActivate } from "../../utils/a11y";

let { lambda, appname } = window.app
const EditStore = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const userId = localStorage.getItem("userId");
    const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
    // // // console.log('loginType',loginType,localStorage.getItem("clientid"));
    const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")
    // // console.log('useruniqueid', useruniqueid);
    const { userData, mapsAPIkey, setMapsAPIkey, isRefreshed, setIsRefreshed, setActiveMenuId } = useContext(contentContext)
    const [add, setAdd] = useState(false);
    const [message, setMessage] = useState(false);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});

    // --- Bank-account reminder ----------------------------------------------
    // Adding a store is deliberately NOT gated on the Stripe bank connection.
    // This page used to redirect to /connectbankaccount whenever payouts weren't
    // enabled yet, which trapped the client in a loop - Add Store bounced to
    // Connect Bank Account, and "I'll do this later" bounced to the Dashboard,
    // so the Add Store form was unreachable. Setting up a location and getting
    // paid for it are separate steps, so we only show a non-blocking reminder
    // here (the Dashboard carries the same standing banner) and let the client
    // create the location either way.
    //
    // Paid plans are the one exception. A plan priced above $0 can only be
    // collected through the client's own connected account, so without one the
    // money would have to be taken and split by hand outside the platform -
    // which is exactly what Connect exists to avoid. So the status is fetched on
    // both flows now: a non-blocking reminder on "add", and a hard check on the
    // Plan Settings save (see validatePreferences).
    const [showBankReminder, setShowBankReminder] = useState(false);
    // Whether the client's account can take paid bookings (payouts on AND Stripe
    // transfers active - see ../stripe/paidBookings). null = never looked up, or the
    // lookup failed. Only an affirmative `false` blocks a paid plan, so a failing
    // status call can't lock a client out of their own pricing.
    const [canTakePaid, setCanTakePaid] = useState(null);
    // A connected account Stripe has paused needs different words from "connect
    // your bank" - they have one.
    const [paidPaused, setPaidPaused] = useState(false);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const response = await tmdbApi.getStripeConnectStatus();
                const bankStatus = response?.result || response;
                if (cancelled) return;
                // An expired session is not an answer about the bank account. Leave
                // canTakePaid at its "unknown" null, exactly as the catch below
                // does - a status lookup must never be the reason a client can't
                // price their own plan.
                if (tmdbApi.isSessionExpired(response)) return;
                setCanTakePaid(canTakePaidBookings(bankStatus));
                setPaidPaused(paidBookingsPaused(bankStatus));
                // The standing top-of-page reminder stays an "add" flow thing;
                // on edit, Plan Settings carries its own notice where it matters.
                setShowBankReminder(!id && bankStatus?.payoutsEnabled !== true);
            } catch (err) {
                // A status lookup failure must never block store creation.
                console.error("getStripeConnectStatus error:", err);
            }
        })();

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // const [mapsAPIkey, setMapsAPIkey] = useState({});
    const [locationFlag, setLocationFlag] = useState(false);
    const [filesData, setFilesData] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);

    const [storeFiles, setStoreFiles] = useState([])
    const [multiUploadFiles, setMultiUploadFiles] = useState([]);
    const [imageLogo, setImageLogo] = useState([]);
    const [data, setData] = useState([])
    const [editData, setEditData] = useState({
        maxVisitor: 0,
        maxPartySize: 0,
        scanExpiryTime: 0,
        automatedExit: 0,
        visitDuration: 15,
        maxLocationCapacity: 0,
        maxFutureDays: 5,
        earlyCheckInWindow: 15,
        // basicPlan: {},
        // premiumPlan: {},
        // vipPlan: {}
    })

    const [plans, setPlans] = useState({
        basicPlan: {
            id: 1,
            name: "Basic",
            //type: "basicPlan",
            price: "",
            benefits: ["", "", "", ""],
            active: false,
            percentage: 0,
            showErrors: false
        },
        premiumPlan: {
            id: 2,
            name: "Premium",
            // type: "premiumPlan",
            price: "",
            benefits: ["", "", "", ""],
            active: false,
            percentage: 0,
            showErrors: false
        },
        vipPlan: {
            id: 3,
            name: "VIP",
            //type: "vipPlan",
            price: "",
            benefits: ["", "", "", ""],
            active: false,
            percentage: 0,
            showErrors: false
        }
    });
    const [mapaddress, setMapAddress] = useState({})
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [deleteLoad, setDeleteLoad] = useState({});
    const [deletePopup, setDeletePopup] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [countries, setCountries] = useState('');
    const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
    const [idc, setIdc] = useState(null);
    const [IdcError, setIdcError] = useState('');
    // const _savedTab = id ? localStorage.getItem(`editStore_tab_${id}`) : null;
    // const [preferenceStatus, setPreferenceStatus] = useState(_savedTab === 'preferences')
    // const [spotsStatus, setSpotsStatus] = useState(_savedTab === 'spots')
    // const [locationStatus, setLocationStatus] = useState(_savedTab !== 'preferences' && _savedTab !== 'spots')

    const [preferenceStatus, setPreferenceStatus] = useState(state?.tab === 'preferences')
    const [spotsStatus, setSpotsStatus] = useState(state?.tab === 'spots')
    const [locationStatus, setLocationStatus] = useState(state?.tab !== 'preferences' && state?.tab !== 'spots')

    const [updateFlagValue, setUpdateFlagValue] = useState(false)
    const [percentageValue, setPercentagevalue] = useState(100)

    const [tempValue, setTempValue] = useState(0);
    const [initialFormData, setInitialFormData] = useState(null);
    const [initialEditData, setInitialEditData] = useState(null);
    const [initialPlans, setInitialPlans] = useState(null);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const [isServerSync, setIsServerSync] = useState(false);
    const [isLocationCreated, setIsLocationCreated] = useState(false);
    // Warning shown after saving preferences that affect plan hours
    const [showHoursUpdateWarning, setShowHoursUpdateWarning] = useState(false);
    const [autoOpenEditHours, setAutoOpenEditHours] = useState(false);

    // ── Working Hours (SPOTS tab) ─────────────────────────────────────
    const WH_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    const WH_HOURS = Array.from({ length: 96 }, (_, i) => {
        const h = Math.floor(i / 4);
        const m = (i % 4) * 15;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    });
    const [whSelectedDay, setWhSelectedDay] = useState('MONDAY');
    const [whSpotsData, setWhSpotsData] = useState([]);
    const [whWorkingHours, setWhWorkingHours] = useState([]);
    const [whStartTime, setWhStartTime] = useState('');
    const [whEndTime, setWhEndTime] = useState('');
    const [whEditMode, setWhEditMode] = useState(false);
    const [whEditId, setWhEditId] = useState(null);
    const [whEndTimeKey, setWhEndTimeKey] = useState(0);
    const [whIsOpen, setWhIsOpen] = useState(true);
    const [whSingleDayData, setWhSingleDayData] = useState(null);
    const [whSavingLoader, setWhSavingLoader] = useState(false);
    // Cached spots for plan-activation validation
    const [existingSpotsData, setExistingSpotsData] = useState([]);

    // Update useEffect for id to set location created status
    // Persist active tab to localStorage
    useEffect(() => {
        if (!id) return;
        if (spotsStatus) localStorage.setItem(`editStore_tab_${id}`, 'spots');
        else if (preferenceStatus) localStorage.setItem(`editStore_tab_${id}`, 'preferences');
        else localStorage.setItem(`editStore_tab_${id}`, 'location');
    }, [locationStatus, preferenceStatus, spotsStatus, id]);

    useEffect(() => {
        if (id) {
            setIsLocationCreated(true);
            getStore();
            // Pre-load spots data so plan-activation validation works on Preferences tab
            const token = localStorage.getItem('token');
            axios.get(`${lambda}/getSpots?appname=${appname}&storeid=${id}&token=${token}`)
                .then(res => {
                    if (res?.data?.result !== 'Invalid token or Expired') {
                        setExistingSpotsData(res?.data?.result || []);
                    }
                })
                .catch(() => { });
        } else {
            setIsLocationCreated(false);
        }
    }, [id]);

    // Refresh spots data whenever the Preferences tab becomes active so that
    // hours saved via SpotsManageCore (a separate component) are reflected in
    // existingSpotsData before the "Delete Working Hours?" check runs.
    useEffect(() => {
        if (preferenceStatus && id) {
            const token = localStorage.getItem('token');
            axios.get(`${lambda}/getSpots?appname=${appname}&storeid=${id}&token=${token}`)
                .then(res => {
                    if (res?.data?.result !== 'Invalid token or Expired') {
                        setExistingSpotsData(res?.data?.result || []);
                    }
                })
                .catch(() => { });
        }
    }, [preferenceStatus, id]);

    const preferenceFields = [
        [
            { label: "Max On-Site Capacity", name: "maxLocationCapacity", min: 0, max: 5000, helperText: "The maximum number of visitors allowed inside this location at any given time." },
            { label: "Time Slot Interval", name: "visitDuration", min: 15, max: 1000, unit: "min", helperText: "How often entry times appear for visitors (Ex: every 15 minutes would show as 12:00, 12:15, 12:30, etc)." },
            { label: "Max Visitors / Slot", name: "maxVisitor", min: 0, max: 100, helperText: "The maximum total number of visitors that can be booked for each time slot." },
            { label: "Max Party Size / Slot", name: "maxPartySize", min: 0, max: 100, helperText: "The maximum number of people allowed in a single Spot (booking)." },
            { label: "Early Check-In Allowance", name: "earlyCheckInWindow", min: 15, max: 100, unit: "min", helperText: "How many minutes before their scheduled time a visitor is allowed to check in." },
            { label: "Check-In Code Expiration", name: "scanExpiryTime", min: 0, max: 180, unit: "min", helperText: "How long a Spot's check-in QR code remains valid after the scheduled entry time." },
            { label: "Booking Window (Days Ahead)", name: "maxFutureDays", min: 5, max: 30, unit: "day", helperText: "How many days in advance visitors can reserve a time slot." },
            { label: "Automatic Check-Out Time", name: "automatedExit", min: 0, max: 600, unit: "min", helperText: "Automatically checks guests out this many minutes after their check-in time (generally based on average visit duration)." },
        ]
    ];




    const [formData, setFormData] = useState({
        businessaddress: '',
        name: '',
        category: '',
        phone: '',
        // A brand-new location has no spot hours yet, so it can only be INACTIVE.
        // Default it so the user isn't forced to pick the single valid option.
        status: 'INACTIVE',
        logo: [],
        storeImages: [],
        idc: "USA(+1)",


    });

    // Error state
    const [errors, setErrors] = useState({
        businessaddress: '',
        name: '',
        category: '',
        phone: ''
    });
    const [preferenceError, setPreferenceError] = useState(null)

    // Alert states
    const [showAlert, setShowAlert] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        type: '',
        message: ''
    });

    const [showPlanHoursDeleteConfirm, setShowPlanHoursDeleteConfirm] = useState(false);
    const [planNamesToDelete, setPlanNamesToDelete] = useState([]);
    const pendingSaveConfirmed = useRef(false);
    // Tracks the previous Spots-tab state so we can refresh the store status when the
    // user leaves the embedded Spots tab (SpotsManageCore renders inline, so this
    // component never unmounts and the mount-time getStore() never re-runs).
    const prevSpotsStatus = useRef(false);


    // (Removed a duplicate unsaved-changes effect that compared the ENTIRE formData
    // object against the 10-field snapshot — it was always "changed". The single
    // effect further below is the source of truth.)

    // Reset initial data after successful save/update
    useEffect(() => {
        if (isServerSync && id) {

            setHasUnsavedChanges(false);
            setPendingAction(null);
            setIsServerSync(false);
        }
    }, [isServerSync, id]);

    // Browser unload protection
    useEffect(() => {
        const handler = (e) => {
            if (!hasUnsavedChanges) return;
            e.preventDefault();
            e.returnValue = "";
        };

        window.addEventListener("beforeunload", handler);
        return () => window.removeEventListener("beforeunload", handler);
    }, [hasUnsavedChanges]);

    // Guard function for tab switches
    const guardUnsavedChanges = (action) => {
        if (hasUnsavedChanges) {
            setPendingAction(() => action);
            setShowDiscardModal(true);
        } else {
            action();
        }
    };
    // useEffect(() => {
    //     validatePreferences()
    // }, [plans]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);


    useEffect(() => {
        window.__HAS_UNSAVED_CHANGES__ = hasUnsavedChanges;

        window.__SHOW_UNSAVED_MODAL__ = (action) => {
            setPendingAction(() => action);
            setShowDiscardModal(true);
        };

        return () => {
            window.__HAS_UNSAVED_CHANGES__ = false;
            window.__SHOW_UNSAVED_MODAL__ = null;
        };
    }, [hasUnsavedChanges]);

    // Handle browser back button
    useEffect(() => {
        // Push a dummy state to history when component mounts
        window.history.pushState(null, "", window.location.href);

        const handlePopState = (event) => {
            if (hasUnsavedChanges) {
                // Prevent navigation by pushing state again
                window.history.pushState(null, "", window.location.href);

                // Show discard modal with navigate back action
                setPendingAction(() => () => {
                    window.history.back();
                });
                setShowDiscardModal(true);
            }
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [hasUnsavedChanges]);

    useEffect(() => {
        const locationCap = parseInt(editData?.maxLocationCapacity || 0);
        const currentVisitor = parseInt(editData?.maxVisitor || 0);

        const allowedMaxVisitor = Math.min(locationCap, 100); // max cap rule

        if (!isNaN(locationCap) && !isNaN(currentVisitor)) {
            if (currentVisitor > allowedMaxVisitor) {
                // Clear only if invalid
                setEditData((prev) => ({
                    ...prev,
                    maxVisitor: '',
                }));
                setFormData((prev) => ({
                    ...prev,
                    maxVisitor: '',
                }));
            }
        }
    }, [editData.maxLocationCapacity]);



    useEffect(() => {
        if (formData.idc) {

            setIdc(formData.idc); // Update state

        }
    }, []);
    useEffect(() => {

        if (selectedPlace) {
            // // // console.log("selectedPlace", selectedPlace)
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                ['businessaddress']: selectedPlace, // Update the changed field
            }));

        }


    }, [selectedPlace]);

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);


    useEffect(() => {
        if (window.site && window.site.common && window.site.common.google) {
            // setMapsAPIkey(window?.site?.common?.google?.mapsAPIkey)
        }

    }, [window.site]);
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/signin");
        }

        GetCountries();
        getCategories()
        if (id) {
            setAdd(false);
            setLocationFlag(true)
            getStore();


        }
        else {
            setAdd(true);
            // GetCompany();
        }

    }, []);
    useEffect(() => {

        setActiveMenuId(200001)

        userActivity();
    }, []);

    // When the user leaves the embedded Spots tab, refresh the store's status/spots
    // (adding hours auto-activates an INACTIVE store on the backend).
    useEffect(() => {
        if (prevSpotsStatus.current && !spotsStatus && id) {
            refreshStoreStatus();
        }
        prevSpotsStatus.current = spotsStatus;
    }, [spotsStatus, id]);

    useEffect(() => {

        if ((multiUploadFiles?.length > 0 || imageLogo?.length > 0) && multiUploadFiles?.length == storeFiles?.length && imageLogo?.length == filesData?.length) {
            submitAPI()
        }


    }, [multiUploadFiles, storeFiles, imageLogo, filesData]);


    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });
            setCountries(response?.result.data);

        } catch {
            // console.log("error");
        }
    };

    const getStore = (e) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'POST',
            url: `${lambda}/getStores?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result) {
                        const result = response?.data?.result?.[0];
                        setFormData(result)
                        const editDataObj = {
                            maxVisitor: result?.maxVisitor ?? 0,
                            maxPartySize: result?.maxPartySize ?? 0,
                            scanExpiryTime: result?.scanExpiryTime ?? 0,
                            automatedExit: result?.automatedExit ?? 0,
                            visitDuration: result?.visitDuration ?? 15,
                            maxLocationCapacity: result?.maxLocationCapacity ?? 0,
                            maxFutureDays: result?.maxFutureDays ?? 5,
                            earlyCheckInWindow: result?.earlyCheckInWindow ?? 15,
                        };
                        setEditData(editDataObj);

                        // setEditData((prevData) => ({
                        //     ...prevData,
                        //     maxVisitor: result?.maxVisitor ?? prevData?.maxVisitor,
                        //     maxPartySize: result?.maxPartySize ?? prevData?.maxPartySize,
                        //     scanExpiryTime: result?.scanExpiryTime ?? prevData?.scanExpiryTime,
                        //     automatedExit: result?.automatedExit ?? prevData?.automatedExit,
                        //     visitDuration: result?.visitDuration ?? prevData?.visitDuration,
                        //     maxLocationCapacity: result?.maxLocationCapacity ?? prevData?.maxLocationCapacity,
                        //     // expiryTime: result?.expiryTime ?? prevData?.expiryTime
                        // }));

                        // setEditData(result?.maxVisitor,result?.maxPartySize,result?.codeExpiration,result?.automatedExit,result?.visitDuration,result?.maxLocationCapacity,)
                        // if (result?.preferences) {
                        //     setPlans(result?.preferences)
                        // }
                        if (result?.preferences) {
                            const mergedPlans = {
                                basicPlan: {
                                    ...plans.basicPlan,
                                    ...result.preferences.basicPlan
                                },
                                premiumPlan: {
                                    ...plans.premiumPlan,
                                    ...result.preferences.premiumPlan
                                },
                                vipPlan: {
                                    ...plans.vipPlan,
                                    ...result.preferences.vipPlan
                                }
                            };
                            setPlans(mergedPlans);

                            // Set initial plans snapshot after state update
                            setTimeout(() => {
                                setInitialPlans(JSON.stringify(mergedPlans));
                            }, 100);
                        }
                        // setIdc(response?.data?.result?.[0]?.idc)
                        if (id) {
                            // For location form, only track fields that user can edit
                            const locationSnapshot = {
                                name: result?.name || '',
                                category: result?.category || '',
                                phone: result?.phone || '',
                                idc: result?.idc || '',
                                status: result?.status || '',
                                businessaddress: result?.businessaddress || '',
                                latitude: result?.latitude || '',
                                longitude: result?.longitude || '',
                                logo: result?.logo?.map(img => img.filepath) || [],
                                storeImages: result?.storeImages?.map(img => img.filepath) || []
                            };

                            setInitialFormData(JSON.stringify(locationSnapshot));
                            setInitialEditData(JSON.stringify(editDataObj));
                            setHasUnsavedChanges(false);
                        }

                        setMapAddress({
                            businessaddress: result?.businessaddress || "",
                            latitude: result?.latitude || "",
                            longitude: result?.longitude || ""
                        })
                        let siteConfig = window?.site?.common;
                        let appResourcesUrl = siteConfig?.imageCloudfront;
                        // let logoPath = appResourcesUrl + result?.logo?.[0].filepath
                        //  // console.log("image",logoPath)
                        // setUploadImg(logoPath)

                    } else {
                        // setInvalidContent(true)
                    }

                }

                // setDisableSaveBtn(false)
            });
    }

    // Lightweight refresh of ONLY status/spots (after leaving the embedded Spots tab).
    // A full getStore() would churn formData/editData/plans/mapaddress; here we patch the
    // status into both formData AND the unsaved-changes baseline so this server-driven
    // change is never seen as a user edit (no false "Unsaved Changes" popup).
    const refreshStoreStatus = () => {
        if (!id) return;
        const token = localStorage.getItem("token");
        axios({
            method: 'POST',
            url: `${lambda}/getStores?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
        }).then((response) => {
            const result = response?.data?.result?.[0];
            if (!result) return;
            setFormData(prev => ({ ...prev, status: result.status, spots: result.spots }));
            setInitialFormData(prev => {
                if (!prev) return prev;
                try {
                    const snap = JSON.parse(prev);
                    snap.status = result.status || '';
                    return JSON.stringify(snap);
                } catch {
                    return prev;
                }
            });
        }).catch(() => { });
    };

    const handleAddressChange = (addressData) => {
        setUpdateFlagValue(true)
        setFormData(prevState => ({
            ...prevState,
            businessaddress: addressData?.fullAddress || ''
        }));
        setErrors(prev => ({ ...prev, address: "" }));
    };

    // Validation function
    const validateForm = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.businessaddress.trim()) {
            tempErrors.address = 'Address is required';
            isValid = false;
        }

        if (!formData.name.trim()) {
            tempErrors.name = 'Store name is required';
            isValid = false;
        }

        if (!formData.category) {
            tempErrors.category = 'Category is required';
            isValid = false;
        }
        if (!formData.status) {
            tempErrors.status = 'Status is required';
            isValid = false;
        }
        if (!formData.logo || formData.logo.length === 0) {
            tempErrors.logo = 'Logo image is required';
            isValid = false;
        }

        if (!formData.phone.trim()) {
            tempErrors.phone = 'Phone number is required';
            isValid = false;
        } else {

            const phone = formData.phone.trim();
            const validations = {
                "USA(+1)": /^\(\d{3}\) \d{3}-\d{4}$/,
                "IND(+91)": /^\d{5}-\d{5}$/
            };

            const pattern = validations[formData.idc]
            if (pattern && !pattern.test(phone)) {
                tempErrors.phone = 'Invalid phone number format';
                isValid = false;
            }
        }

        setErrors(tempErrors);
        return isValid;
    };
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        setIdc(newCountry); // Update state
        setFormData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
        setEditData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdateFlagValue(true);

        let formattedValue = value;
        // debugger
        if (name === "phone") {
            let numericValue = value.replace(/[-()]/g, '').replace(/\D/g, ""); // Remove non-numeric characters

            if (idc === "USA(+1)") {
                // Format: (XXX) XXX-XXXX
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (idc === "IND(+91)") {
                // Format: XXXXX-XXXXX
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
        }

        // Location fields (name/category/phone/status) belong in formData only.
        // Do NOT mirror them into editData — that object tracks visit-settings, and
        // polluting it makes the Preferences tab compare dirty (and survives a Discard).
        setFormData(prev => ({ ...prev, [name]: formattedValue }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const preferenceChange = (e) => {
        const { name, value } = e.target;

        // Keep only digits
        let numericValue = value.replace(/[^0-9]/g, "");

        // Get field config to check max limit
        let field = preferenceFields?.[0]?.find((item) => item.name === name);
        let max = field?.max;

        // Dynamic override for maxVisitor
        if (name === "maxVisitor") {
            const locationCap = parseInt(editData?.maxLocationCapacity || 0);
            if (!isNaN(locationCap) && locationCap > 0) {
                max = Math.min(locationCap, 100); // Clamp to 100 max
            }
        }

        // Block input if exceeds max
        if (max !== undefined && parseInt(numericValue) > max) {
            return;
        }

        // 🟢 Relationship Logic Between maxVisitor & partySize
        const currentPartySize = parseInt(editData.maxPartySize || 0);
        const currentMaxVisitor =
            name === "maxVisitor"
                ? parseInt(numericValue || 0)
                : parseInt(editData.maxVisitor || formData.maxVisitor || 0);

        // console.log("DEBUG:", { name, numericValue, currentPartySize, currentMaxVisitor });

        // If editing maxVisitor and it's reduced below current partySize
        if (name === "maxVisitor" && currentPartySize > parseInt(numericValue)) {
            setEditData((prev) => ({
                ...prev,
                maxPartySize: parseInt(numericValue),
            }));
            setFormData((prev) => ({
                ...prev,
                maxPartySize: parseInt(numericValue),
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                maxPartySize: "",
            }));
        }

        // If editing partySize and it goes beyond maxVisitor → block it
        if (name === "maxPartySize" && parseInt(numericValue) > currentMaxVisitor && currentMaxVisitor > 0) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                maxPartySize: "Party size cannot exceed Max Visitor count.",
            }));
            return; // stop updating value
        } else if (name === "maxPartySize") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                maxPartySize: "",
            }));
        }

        // Continue normal updates
        setUpdateFlagValue(true);

        // Determine what to store
        const finalValue = numericValue !== "" ? parseInt(numericValue) : "";

        setEditData((prev) => ({
            ...prev,
            [name]: finalValue,
        }));

        setFormData((prev) => ({
            ...prev,
            [name]: finalValue,
        }));

        // Update field-level errors
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: finalValue >= 1 ? "" : prevErrors[name],
        }));
    };

    console.log('formdata', formData)


    const submitAPI = async () => {

        let logoImage = imageLogo;
        let geoData = {}
        if (Object.keys(addressData)?.length > 0) {
            geoData = {
                latitude: addressData?.geolocation?.location?.lat?.(),
                longitude: addressData?.geolocation?.location?.lng?.(),
                url: addressData?.url,
                state: addressData?.state,
                city: addressData?.city,
                county: addressData?.county,
                businessaddress: addressData?.fullAddress
            }
        }



        try {

            setIsLoading(true);
            if (id) {

                const token = localStorage.getItem("token")
                //// console.log("logoImageedit logoImage", logoImage)
                // console.log("logoImageedit multiUploadFiles", multiUploadFiles)
                let locationImages = formData?.storeImages
                const updatedStoreImages = [...locationImages, multiUploadFiles];
                // console.log("updatedStoreImages", updatedStoreImages);
                let cleanedData = updatedStoreImages.flat().filter(item => !(typeof item === "string" && item.startsWith("blob:")));
                // console.log("cleanedData", cleanedData);
                let payload = { ...editData };
                // Location fields live in formData (handleChange no longer mirrors them
                // into editData). Send them explicitly so edits persist on update.
                payload["name"] = formData?.name;
                payload["category"] = formData?.category;
                payload["phone"] = formData?.phone;
                payload["idc"] = formData?.idc;
                payload["businessaddress"] = formData?.businessaddress;
                if (logoImage && logoImage?.length > 0) {
                    payload["logo"] = logoImage
                }

                if (cleanedData && cleanedData?.length > 0) {
                    payload["storeImages"] = cleanedData
                }
                // Persist the status chosen in the dropdown. ACTIVE is only selectable
                // once the store has spot hours (the ACTIVE option is disabled otherwise),
                // and the backend enforces the same rule, so this can't activate an
                // hours-less store while still allowing manual deactivation.
                if (formData?.status) {
                    payload["status"] = formData.status;
                }

                let mergedData = { ...payload, ...geoData };
                // console.log(mergedData, 'mergedData');


                const response = await axios.post(
                    `${lambda}/updateStore?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
                    mergedData,
                );

                if (response.data.result) {
                    setMultiUploadFiles([])
                    setImageLogo([])
                    setStoreFiles([])
                    setFilesData([])

                    setMessage(true);
                    setIsLoading(false);
                    setAdd(false)
                    setLoaderEnable(false)
                    setLocationFlag(true)
                    setToastMessage("Location Updated Successfully")
                    setToastType("success")

                    getStore();
                    setPreferenceStatus(true);
                    setLocationStatus(false);
                    setIsServerSync(true);
                } else if (response.data.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    setIsLoading(false);
                    setLoaderEnable(false)
                }
            } else {
                const token = localStorage.getItem("token")
                if (logoImage && logoImage?.length > 0) {
                    formData["logo"] = logoImage
                }

                formData["createdBy"] = {
                    name: userData?.name, // Replace with actual username
                    userid: useruniqueid
                }

                if (multiUploadFiles && multiUploadFiles?.length > 0) {
                    formData['storeImages'] = multiUploadFiles
                }
                formData['status'] = "INACTIVE"
                // console.log(formData, 'formDatddda');
                let mergedData = { ...formData, ...geoData };

                const response = await axios.put(
                    `${lambda}/addStore?appname=${appname}&userid=${useruniqueid}`,
                    mergedData,
                );
                if (response.data.result) {
                    id = response?.data?.result;
                    navigate("/editstore/" + id);

                    setMessage(true);
                    setIsLoading(false);
                    setAdd(false)
                    setLoaderEnable(false)
                    setLocationFlag(true)
                    setMultiUploadFiles([])
                    setImageLogo([])
                    setStoreFiles([])
                    setFilesData([])
                    setToastMessage("Location Created Successfully")
                    setToastType("success")
                    getStore()
                    setPreferenceStatus(true);
                    setLocationStatus(false);
                    setIsServerSync(true);
                } else if (response.data.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    setIsLoading(false);
                    setLoaderEnable(false)
                }
            }
        } catch (error) {
            setAlertConfig({
                title: 'Error',
                type: 'error',
                message: error.response?.data?.message || 'Something went wrong'
            });
            setShowAlert(true);
            setIsLoading(false);
            setLoaderEnable(false);
        }
    };

    useEffect(() => {
        // Add mode = no store id yet. Once an id exists we always use the edit-mode
        // comparison below (the old `|| !isLocationCreated` made a just-created store
        // briefly fall into add-mode). NOTE: `status` is intentionally excluded — it
        // auto-defaults to 'INACTIVE', so it must not count as a user-entered field.
        if (!id) {
            // For add mode, track if any field has been filled
            const hasData = formData?.name ||
                formData?.category ||
                formData?.phone ||
                formData?.businessaddress ||
                formData?.logo?.length > 0 ||
                filesData?.length > 0 ||
                storeFiles?.length > 0;
            setHasUnsavedChanges(hasData);
        } else {
            // For edit mode, check changes based on active tab only
            if (locationStatus && initialFormData) {
                // Location tab - compare form data
                const currentSnapshot = {
                    name: formData?.name || '',
                    category: formData?.category || '',
                    phone: formData?.phone || '',
                    idc: formData?.idc || '',
                    status: formData?.status || '',
                    businessaddress: formData?.businessaddress || '',
                    latitude: formData?.latitude || '',
                    longitude: formData?.longitude || '',
                    logo: formData?.logo?.map(img => img?.filepath || img) || [],
                    storeImages: formData?.storeImages?.map(img => img?.filepath || img) || []
                };

                const currentData = JSON.stringify(currentSnapshot);
                const isChanged = currentData !== initialFormData;
                const hasNewFiles = filesData?.length > 0 || storeFiles?.length > 0;

                setHasUnsavedChanges(isChanged || hasNewFiles);
            } else if (preferenceStatus) {
                // Preferences tab - compare editData and plans (removed condition check)
                const editDataChanged = initialEditData &&
                    JSON.stringify(editData) !== initialEditData;

                let plansChanged = false;
                if (initialPlans) {
                    const currentPlansSnapshot = JSON.stringify(plans);
                    plansChanged = currentPlansSnapshot !== initialPlans;
                }

                setHasUnsavedChanges(editDataChanged || plansChanged);
            } else if (spotsStatus) {
                // Spots tab - no unsaved changes tracking
                setHasUnsavedChanges(false);
            }
        }
    }, [formData, editData, plans, filesData, storeFiles, locationStatus, preferenceStatus, spotsStatus, id, isLocationCreated, initialFormData, initialEditData, initialPlans]);


    // Handle form submission
    const handleSubmit = async (e) => {
        setLoaderEnable(true)
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (!validateForm()) {

            setLoaderEnable(false)
            return;
        }


        if (filesData?.length > 0) {
            await handleUploadSubmit()
        }

        if (storeFiles?.length > 0) {
            await uploadStoreImages()
        }
        if (filesData?.length == 0 && storeFiles?.length == 0) {
            submitAPI()
        }
    };
    // const handleBack = () => {
    //     guardUnsavedChanges(() => {
    //         navigate("/locations");
    //     });
    // };
    const handleBack = () => {
        const navigateBack = () => {
            navigate("/locations");
        };

        // Only show discard modal if there are unsaved changes
        if (hasUnsavedChanges) {
            guardUnsavedChanges(navigateBack);
        } else {
            navigateBack();
        }
    };


    const handleDiscardChanges = () => {
        if (!isLocationCreated) {
            // In add mode, clear all form data
            setFormData({
                name: '',
                category: '',
                phone: '',
                status: 'INACTIVE',
                businessaddress: '',
                logo: [],
                storeImages: []
            });
            setFilesData([]);
            setStoreFiles([]);
            setMultiUploadFiles([]);
            setImageLogo([]);
            setAddressData({});
            setMapAddress({
                businessaddress: "",
                latitude: "",
                longitude: ""
            });
        } else {
            if (locationStatus && initialFormData) {
                // Merge the 10-field snapshot back in — don't replace the whole object
                // (that would drop _id, storeid, spots, preferences, etc.).
                setFormData(prev => ({ ...prev, ...JSON.parse(initialFormData) }));
                setFilesData([]);
                setStoreFiles([]);
                setMultiUploadFiles([]);
            } else if (preferenceStatus) {
                if (initialEditData) setEditData(JSON.parse(initialEditData));
                if (initialPlans) setPlans(JSON.parse(initialPlans));
            }
        }

        setHasUnsavedChanges(false);
        setShowDiscardModal(false);
        setErrors({});

        if (pendingAction) {
            window.__HAS_UNSAVED_CHANGES__ = false;
            pendingAction();
            setPendingAction(null);
        }
    };

    // Handle update from modal
    const handleUpdateFromModal = () => {
        setShowDiscardModal(false);

        if (locationStatus) {
            handleSubmit();
        } else if (preferenceStatus) {
            handleSave();

        }
    };


    const getCategories = async () => {
        setIsLoading(true)
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(`${lambda}/getCategories?appname=${appname}&token=${token}&pagename=store`);

            if (response?.data?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true);
                setIsLoading(false)
            } else {

                setData(response?.data?.result);
                setIsLoading(false)
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };


    const uploadStoreImages = async () => {
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)
        //    // // console.log("filesData: ", validFiles);
        //   let filesData = validFiles;
        if (storeFiles && storeFiles?.length > 0) {

            const uploadPromises = Array.from(storeFiles).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    // // console.log("data", data)
                    const newFile = {
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }
                    // const updatedFiles = [...multiUploadFiles, ...newFile];
                    // console.log("store image newFilenewFile", newFile)


                    axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    setMultiUploadFiles(prevItems => [...prevItems, newFile]);

                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);
                return true
            } catch (error) {
                console.error('Error during file upload:', error);
                return false
            }
        } else {
            return true
        }

    }

    const handleUploadSubmit = async () => {
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)
        if (filesData && filesData?.length > 0) {

            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    // // // console.log("data", data)
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    // const updatedFiles = [...imageLogo, ...newFile];
                    // setImageLogo(updatedFiles)

                    const uploadPromise = axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    const updatedFiles = [...imageLogo, ...newFile];
                                    setImageLogo(updatedFiles)

                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);
                return true
            } catch (error) {
                console.error('Error during file upload:', error);
                return false
            }
        } else {
            return true
        }

    }



    const handleFileChange = (event) => {
        setUpdateFlagValue(true)
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files
        // const selectedFilesSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);  //for multiple files
        // // console.log("selectedFile ", selectedFile)
        // // console.log("selectedFiles ", selectedFiles)
        const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
            setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
            setToastType("warning")
            event.target.value = null;
            return;
        }
        else if (selectedFile?.size < fileSize) {
            // if (selectedFile) {
            //     // Create a preview URL for the image
            //     const previewUrl = URL.createObjectURL(selectedFile);
            //     setFormData(previewUrl); // Store the URL in state
            // }
            if (selectedFile) {
                const previewUrl = URL.createObjectURL(selectedFile);
                setFormData(prev => ({
                    ...prev,
                    logo: [{ filepath: previewUrl }]
                }));

                // Clear logo error when a file is selected
                setErrors(prev => ({ ...prev, logo: "" }));
            }
            setFilesData(selectedFiles)

        } else {
            setToastMessage("File size should not exceed 5MB"); // Set the error message
            setToastType("warning")
            event.target.value = null;

        }




    };

    // Handle store image upload
    const handleStoreImageUpload = (e) => {
        setUpdateFlagValue(true)
        const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

        // console.log("selectedFiles: ", selectedFiles);

        if (selectedFiles.length === 0) return; // Exit if no files are selected

        let maxFileSize = 1048612 * 5; // 5MB

        // Filter out files that exceed the size limit
        const validFiles = selectedFiles.filter(file => file.size < maxFileSize);
        // // console.log("Image URLs validFiles: ", validFiles);
        if (validFiles.length === 0) {
            setFileSizeError(true);
            return;
        }
        // console.log("Image URLs: ", validFiles);
        // Create preview URLs for valid files
        validFiles.forEach(file => {
            file["image"] = URL.createObjectURL(file)
            setStoreFiles(prevItems => [...prevItems, file]);
        });


    };

    const handleClose = () => {
        setShowDeleteAlert(false)
        setDeletePopup(false)
    };

    const handleRemove = () => {
        setUpdateFlagValue(true)
        let logo = formData && formData?.logo && formData?.logo?.[0] && formData?.logo?.[0]?.fileid
        if (logo) {
            setShowDeleteAlert(true)
        } else {
            setFormData(prev => ({
                ...prev,
                logo: []
            }));
        }



    }

    const deleteclick = (item, index) => {
        // console.log("item", item)
        setUpdateFlagValue(true)
        let storeimage = item?.fileid;
        if (storeimage) {
            setDeleteLoad(storeimage)
            setDeletePopup(true)
            // setToastMessage("Client Details Updated Successfully")
            // setToastType("success")
        } else {
            setStoreFiles(prevImages => prevImages.filter((_, i) => i !== index));

        }

    }

    const deletePopupClick = async () => {
        // setDeleteLoad(true)

        setDeletePopup(false)
        const token = localStorage.getItem('token');
        // console.log("deleteItem", formData)
        let storeid = formData?.storeid
        let images = formData?.storeImages;
        // console.log("images", images)
        let sameFile = deleteLoad;
        // console.log("sameFile", sameFile)
        let filteredImage = images.filter(img => img.fileid !== sameFile);
        // console.log("uniqueImages", filteredImage);

        setEditData(prev => ({
            ...prev,
            "storeImages": filteredImage
        }));
        setFormData(prev => ({
            ...prev,
            "storeImages": filteredImage // Clear the logo array
        }));

    }
    const handleDeleteClick = async () => {
        // setDeleteLoad(true)
        setShowDeleteAlert(false)
        //const token = localStorage.getItem('token');
        //// console.log("deleteItem", formData)
        //let storeid = formData?.storeid

        setEditData(prev => ({
            ...prev,
            "logo": []
        }));

        setFormData(prev => ({
            ...prev,
            logo: [] // Clear the logo array
        }));

    }

    // // console.log("addressDataaddressData", formData)
    // // console.log(editData, 'editData');

    const spotClick = () => {
        navigate("/spotsmanage/" + id);
        // navigate("/spotsmanage");
    }
    const handleTabSwitchOld = (tab) => {

        const planValues = Object.values(plans);

        // Filter active plans
        const activePlans = planValues.filter(plan => plan.active);



        if (tab === "preferences") {
            if (!validateForm()) {
                setToastMessage("Please save location info before continuing to the next section.");
                setToastType("error");
                setPreferenceStatus(false);
                return;
            } else {
                setPreferenceStatus(true);
                setLocationStatus(false);
                setSpotsStatus(false)
            }

        }
        else if (tab === "spots") {
            if (!validateForm()) {
                setToastMessage("Please save location info before continuing to the next section.");
                setToastType("error");
                setSpotsStatus(false);
            } else if (!validatePreferences()) {
                setToastMessage("Please save preferences before proceeding.");
                setToastType("error");
                setSpotsStatus(false);
            } else if (activePlans.length === 0) {
                setPreferenceError("Please select at least one plan");
                setToastMessage("Please save preferences before proceeding.");
                setToastType("error");

                setLoaderEnable(false);
                return;
            } else {
                navigate("/spotsmanage/" + id);
                return;
            }
        }
        else if (tab === "location") {
            setLocationStatus(true);
            setPreferenceStatus(false);
            setSpotsStatus(false)
        }
    };
    const handleTabSwitch = (tab) => {
        const planValues = Object.values(plans);
        const activePlans = planValues.filter(plan => plan.active);

        // Check if location is created for preferences/spots tabs
        if (!isLocationCreated && (tab === "preferences" || tab === "spots")) {
            setToastMessage("Please save location info before continuing to the next section.");
            setToastType("error");
            setMessage(true);
            return;
        }

        const switchTab = () => {
            if (tab === "location") {
                setLocationStatus(true);
                setPreferenceStatus(false);
                setSpotsStatus(false);
            } else if (tab === "preferences") {
                // Validate location info before switching to preferences
                if (!validateForm()) {
                    setToastMessage("Please complete all required fields in Location Info.");
                    setToastType("error");
                    setMessage(true);
                    return;
                }
                setLocationStatus(false);
                setPreferenceStatus(true);
                setSpotsStatus(false);
            } else if (tab === "spots") {
                // Validate location info first
                if (!validateForm()) {
                    setToastMessage("Please complete all required fields in Location Info.");
                    setToastType("error");
                    setMessage(true);
                    return;
                }

                // Then validate preferences
                if (!validatePreferences()) {
                    setToastMessage("Please complete all required fields in Preferences.");
                    setToastType("error");
                    setMessage(true);
                    setLocationStatus(false);
                    setPreferenceStatus(true); // Switch to preferences tab to show errors
                    setSpotsStatus(false);
                    return;
                }

                // Check if at least one plan is active
                if (activePlans.length === 0) {
                    setPreferenceError("Please select at least one plan");
                    setToastMessage("Please activate at least one plan in Preferences.");
                    setToastType("error");
                    setMessage(true);
                    setLocationStatus(false);
                    setPreferenceStatus(true); // Switch to preferences tab to show error
                    setSpotsStatus(false);
                    return;
                }

                setLocationStatus(false);
                setPreferenceStatus(false);
                setSpotsStatus(true);
                return;
            }
        };

        // Guard unsaved changes only in edit mode
        if (isLocationCreated) {
            guardUnsavedChanges(switchTab);
        } else {
            // In add mode, only allow location tab
            if (tab === "location") {
                switchTab();
            }
        }
    };

    // console.log("TempValueeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", tempValue)

    const handleConfirmDeletePlanHours = async () => {
        setShowPlanHoursDeleteConfirm(false);
        try {
            const token = localStorage.getItem('token');
            await Promise.all(
                existingSpotsData
                    .filter(spot => spot?.storespotdayid)
                    .map(spot => {
                        const filteredPlanHours = (spot.spotdayplanstartend || []).filter(
                            h => !planNamesToDelete.some(
                                name => h.plan?.toLowerCase() === name?.toLowerCase()
                            )
                        );
                        return axios.post(
                            `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${spot.storespotdayid}`,
                            {
                                storeid: id,
                                spotstype: spot.spotstype || 'REGULAR',
                                spotdaystartend: spot.spotdaystartend || [],
                                spotdayplanstartend: filteredPlanHours,
                                days: spot.days || [],
                                isopen: spot.isopen !== false,
                                createdBy: { userId: useruniqueid },
                            }
                        );
                    })
            );
            await loadWhData(id);
        } catch (err) {
            console.error('Error deleting plan hours:', err);
        }
        pendingSaveConfirmed.current = true;
        handleSave();
    };

    const toggleActive = (id, key, e) => {
        setPreferenceError("")
        let errorsList = { ...errors };
        errorsList[`${key}_price`] = "";
        errorsList[`${key}_benefit_0`] = "";

        setUpdateFlagValue(true);

        // console.log("key ", key, id)


        if (tempValue == 0) {
            setPlans((prevPlans) => {
                // Clone previous state
                let updatedPlans = { ...prevPlans };
                let benifits = updatedPlans[key].benefits.map(item => {
                    if (!e.target.checked) {
                        item = ''
                    }
                    return item
                })

                // Toggle active state
                updatedPlans[key] = {
                    ...updatedPlans[key],
                    active: !updatedPlans[key].active,
                    price: e.target.checked ? updatedPlans[key].price : '',
                    benefits: benifits
                };
                // Get all active plans
                let activePlans = Object.keys(updatedPlans).filter(
                    (planKey) => updatedPlans[planKey].active
                );
                // Calculate percentage distribution
                let newPercentage = activePlans.length > 0 ? Math.floor(100 / activePlans.length) : 0;
                // Update active plans' percentage
                activePlans.forEach((planKey) => {
                    updatedPlans[planKey] = {
                        ...updatedPlans[planKey],
                        percentage: newPercentage,
                    };
                });
                // Set inactive plans' percentage to 0
                Object.keys(updatedPlans).forEach((planKey) => {
                    if (!updatedPlans[planKey].active) {
                        updatedPlans[planKey] = {
                            ...updatedPlans[planKey],
                            percentage: 0,
                        };
                    }
                });
                return { ...updatedPlans }; // Ensure a new state object is returned
            });
        } else {
            let pValue = percentageValue - tempValue
            setPlans((prevPlans) => {
                let updatedPlans = { ...prevPlans };

                // Update the edited plan's percentage
                updatedPlans[key] = {
                    ...updatedPlans[key],
                    percentage: pValue,
                    active: !updatedPlans[key].active,
                };

                // Set inactive plans' percentage to 0
                Object.keys(updatedPlans).forEach((planKey) => {
                    if (!updatedPlans[planKey].active) {
                        updatedPlans[planKey] = {
                            ...updatedPlans[planKey],
                            percentage: 0,
                        };
                    }
                });

                return updatedPlans;
            });
            setTempValue(pValue)
            setPercentagevalue(pValue)
        }


        setErrors(errorsList);

    };

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        let presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }


    const handlePercentageChange = (e, id, key) => {
        let value = Number(e.target.value);
        if (isNaN(value) || value < 0 || value > 100) return;

        setPlans((prevPlans) => {
            const updatedPlans = { ...prevPlans };
            const prevValue = prevPlans[key].percentage;
            const diff = value - prevValue;

            updatedPlans[key] = {
                ...updatedPlans[key],
                percentage: value,
            };

            const otherKeys = Object.keys(prevPlans).filter(k => k !== key);
            const activeOthers = otherKeys.filter(k => updatedPlans[k].active);

            if (activeOthers.length === 0) return updatedPlans;

            if (key === "basicPlan") {
                // Adjust premium & vip
                const adjust = -diff;
                const share = Math.floor(adjust / activeOthers.length);
                const remainder = adjust % activeOthers.length;

                activeOthers.forEach((k, i) => {
                    updatedPlans[k].percentage = Math.max(
                        0,
                        Math.min(
                            100,
                            updatedPlans[k].percentage + share + (i === 0 ? remainder : 0)
                        )
                    );
                });
            } else if (key === "premiumPlan" || key === "vipPlan") {
                // Adjust only basic
                if (updatedPlans.basic && updatedPlans.basic.active) {
                    updatedPlans.basic.percentage = Math.max(
                        0,
                        Math.min(100, updatedPlans.basic.percentage - diff)
                    );
                }
            }

            // Final correction to make total exactly 100
            const total = Object.values(updatedPlans).reduce(
                (sum, plan) => (plan.active ? sum + plan.percentage : sum),
                0
            );

            const delta = 100 - total;
            const adjustableKey = Object.keys(updatedPlans).find(k => k !== key && updatedPlans[k].active);
            if (adjustableKey && delta !== 0) {
                updatedPlans[adjustableKey].percentage = Math.max(
                    0,
                    Math.min(100, updatedPlans[adjustableKey].percentage + delta)
                );
            }

            return updatedPlans;
        });

        setTempValue(value);
    };





    const handlePlansChange = (id, field, value, index = null) => {
        setUpdateFlagValue(true);
        // console.log("field ", field, value, index, id);

        if (field === "price" && isNaN(value) || Number(value) < 0) {
            return; // Ignore non-numeric input
        }

        setPlans((prevPlans) => {
            const updatedPlans = Object.keys(prevPlans).reduce((acc, key) => {
                const plan = prevPlans[key];

                if (plan?.id === id) {
                    if (field !== "price") {
                        // ✅ Update benefits array properly
                        const updatedBenefits = [...(plan?.benefits ?? [])];
                        updatedBenefits[index] = value;
                        acc[key] = { ...plan, benefits: updatedBenefits };
                    } else {
                        // ✅ Update price field
                        acc[key] = { ...plan, [field]: value };
                    }
                } else {
                    acc[key] = plan;
                }
                return acc;
            }, {});

            // console.log("Updated Plans:", updatedPlans);
            return updatedPlans;
        });

    };

    const capitalizeFirstLetter = (string) => {
        if (typeof string !== 'string') return '';

        let value = string.replace(/([A-Z])/g, " $1");
        let field = value.charAt(0).toUpperCase() + value.slice(1);
        return field;
    };

    // ── Working Hours Utilities ───────────────────────────────────────
    const whParseTime = (str) => {
        if (!str) return { hour: 0, minute: 0 };
        const [h, m] = str.split(':').map(Number);
        return { hour: isNaN(h) ? 0 : h, minute: isNaN(m) ? 0 : m };
    };

    const whFormatTime = (str, day) => {
        if (!str) return '';
        const { hour: h, minute: m } = whParseTime(str);
        const period = h < 12 ? 'AM' : 'PM';
        const dh = h === 0 ? 12 : h > 12 ? h - 12 : h;
        const dm = String(m).padStart(2, '0');
        const dayLabel = day
            ? ` (${day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase()})`
            : '';
        return `${dh}:${dm} ${period}${dayLabel}`;
    };

    const whGetNextDay = (day) => {
        const idx = WH_DAYS.indexOf(day?.toUpperCase());
        return idx >= 0 ? WH_DAYS[(idx + 1) % 7] : day;
    };

    const whGetStartOptions = () =>
        WH_HOURS.filter(h => {
            if (whEditMode && whEditId !== null) {
                const editing = whWorkingHours.find(wh => wh.id === whEditId);
                if (editing && editing.starttime === h) return true;
            }
            return !whWorkingHours.some(wh => {
                if (whEditMode && wh.id === whEditId) return false;
                return wh.starttime === h;
            });
        }).map(h => ({ value: h, label: whFormatTime(h, whSelectedDay) }));

    const whGetEndOptions = () => {
        if (!whStartTime) return [];
        const startIdx = WH_HOURS.indexOf(whStartTime);
        if (startIdx === -1) return [];
        return Array.from({ length: WH_HOURS.length - 1 }, (_, i) => {
            const idx = (startIdx + 1 + i) % WH_HOURS.length;
            const isNextDay = (startIdx + 1 + i) >= WH_HOURS.length;
            const day = isNextDay ? whGetNextDay(whSelectedDay) : whSelectedDay;
            return { value: WH_HOURS[idx], label: whFormatTime(WH_HOURS[idx], day), nextDay: isNextDay, day };
        });
    };

    // ── Working Hours API ─────────────────────────────────────────────
    const loadWhData = async (storeId) => {
        if (!storeId) return;
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(
                `${lambda}/getSpots?appname=${appname}&storeid=${storeId}&token=${token}`
            );
            if (res?.data?.result === 'Invalid token or Expired') {
                setShowSessionPopupup(true);
                return;
            }
            const spots = res?.data?.result || [];
            setWhSpotsData(spots);
            setExistingSpotsData(spots);
            whLoadDayHours(spots, whSelectedDay);
        } catch (e) {
            console.error('Error loading working hours:', e);
        }
    };

    const whLoadDayHours = (spots, day) => {
        const upper = day.toUpperCase();
        const daySpot = spots.find(s =>
            Array.isArray(s.days) && s.days.some(d => d.toUpperCase() === upper)
        );
        setWhSingleDayData(daySpot || null);
        const hours = spots
            .flatMap(s => s.spotdaystartend || [])
            .filter(h => h.day?.toUpperCase() === upper);
        setWhWorkingHours(hours);
        setWhIsOpen(daySpot ? daySpot.isopen !== false : true);
        setWhStartTime('');
        setWhEndTime('');
        setWhEditMode(false);
        setWhEditId(null);
        setWhEndTimeKey(k => k + 1);
    };

    const saveWhData = async () => {
        if (!id) return;
        setWhSavingLoader(true);
        try {
            const token = localStorage.getItem('token');
            const payload = {
                storeid: id,
                spotstype: 'REGULAR',
                spotdaystartend: whWorkingHours,
                spotdayplanstartend: whSingleDayData?.spotdayplanstartend || [],
                days: [whSelectedDay],
                isopen: whIsOpen,
                createdBy: { userId: useruniqueid },
            };
            const url = whSingleDayData?.storespotdayid
                ? `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${whSingleDayData.storespotdayid}`
                : `${lambda}/addSpots?appname=${appname}&token=${token}`;
            await axios.post(url, payload);
            setToastMessage('Working hours saved successfully');
            setToastType('success');
            await loadWhData(id);
        } catch (e) {
            setToastMessage('Error saving working hours. Please try again.');
            setToastType('error');
        }
        setWhSavingLoader(false);
    };

    // ── Working Hours Handlers ────────────────────────────────────────
    const handleWhDayChange = (day) => {
        setWhSelectedDay(day);
        whLoadDayHours(whSpotsData, day);
    };

    const handleWhAddHours = () => {
        if (!whStartTime || !whEndTime) {
            setToastMessage('Please select both start and end times');
            setToastType('error');
            return;
        }
        const endOpt = whGetEndOptions().find(o => o.value === whEndTime);
        const newHour = {
            id: whEditMode && whEditId !== null ? whEditId : Date.now(),
            day: whSelectedDay,
            starttime: whStartTime,
            endtime: whEndTime,
            endDay: endOpt?.nextDay ? whGetNextDay(whSelectedDay) : whSelectedDay,
        };
        setWhWorkingHours(prev =>
            whEditMode && whEditId !== null
                ? prev.map(h => h.id === whEditId ? newHour : h)
                : [...prev, newHour]
        );
        setWhEditMode(false);
        setWhEditId(null);
        setWhStartTime('');
        setWhEndTime('');
        setWhEndTimeKey(k => k + 1);
    };

    const handleWhEditHour = (hour) => {
        setWhStartTime(hour.starttime);
        setWhEndTime(hour.endtime);
        setWhEditMode(true);
        setWhEditId(hour.id);
        setWhEndTimeKey(k => k + 1);
    };

    const handleWhDeleteHour = (hourId) => {
        setWhWorkingHours(prev => prev.filter(h => h.id !== hourId));
    };


    console.log('preference status', locationStatus, preferenceStatus)

    const handleSave = async (e) => {

        console.log('kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk')
        setPreferenceError(null)
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        setLoaderEnable(true);
        // console.log("Updated Plans Before Validation:", plans);
        let total = Object.values(plans)
            .filter(plan => plan.active)
            .reduce((sum, plan) => sum + plan.percentage, 0);

        // console.log("Total Percentage:", total);
        // return total;
        if (total > 100) {
            setErrors(prevErrors => ({
                ...prevErrors,
                percentage: "Total percentage cannot exceed 100%",
            }));
            setLoaderEnable(false);
            return;
        }
        const planValues = Object.values(plans);

        // Filter active plans
        const activePlans = planValues.filter(plan => plan.active);

        const isValid = validatePreferences(); // Validate once and store the result
        if (activePlans.length === 0) {
            setPreferenceError("Please select at least one plan");



            setLoaderEnable(false);
            return;
        }
        if (!isValid) {
            // console.log("Validation failed. Aborting API call.");
            setLoaderEnable(false);
            return;
        }

        if (!pendingSaveConfirmed.current) {
            const hasExistingHours = existingSpotsData.some(
                spot => spot?.spotdaystartend?.length > 0 || spot?.spotdayplanstartend?.length > 0
            );
            const prevEdit = initialEditData ? JSON.parse(initialEditData) : null;

            // If a plan was disabled since last save, delete only that plan's hours.
            const prevPlans = initialPlans ? JSON.parse(initialPlans) : null;
            if (prevPlans) {
                const disabledNames = Object.keys(plans)
                    .filter(k => prevPlans[k]?.active === true && plans[k]?.active === false)
                    .map(k => plans[k]?.name)
                    .filter(Boolean);
                if (disabledNames.length > 0) {
                    const hasPlanHours = existingSpotsData.some(spot =>
                        (spot.spotdayplanstartend || []).some(h =>
                            disabledNames.some(n => h.plan?.toLowerCase() === n?.toLowerCase())
                        )
                    );
                    if (hasPlanHours) {
                        setPlanNamesToDelete(disabledNames);
                        setShowPlanHoursDeleteConfirm(true);
                        setLoaderEnable(false);
                        return;
                    }
                }
            }
        }
        pendingSaveConfirmed.current = false;

        try {

            setLoaderEnable(true);
            let data = {};
            data["preferences"] = plans

            // console.log("Data to be sent:", data);

            if (id) {
                let mergedData = { ...editData, ...data };
                // Status is owned by the Location tab + backend activation. The
                // preferences save must not change it (the old stale-`spots` check
                // here used to re-deactivate stores right after hours were added).
                delete mergedData.status;
                // console.log("Merged Data for API:", mergedData);
                const response = await axios.post(
                    `${lambda}/updateStore?appname=${appname}&userid=${useruniqueid}&storeid=${id}`,
                    mergedData
                );

                // console.log("API Response:", response);

                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                } else if (response?.data?.result) {
                    setMultiUploadFiles([]);
                    setImageLogo([]);
                    setStoreFiles([]);

                    setMessage(true);
                    setIsLoading(false);
                    setAdd(false);
                    setLoaderEnable(false);
                    setLocationFlag(true);
                    setToastMessage("Preferences Updated Successfully");
                    setToastType("success");

                    // Check if hours-affecting fields changed vs initial saved values
                    const prevEdit = initialEditData ? JSON.parse(initialEditData) : null;
                    const prevPlans = initialPlans ? JSON.parse(initialPlans) : null;
                    const hoursAffected = prevEdit && (
                        prevEdit.maxVisitor !== editData.maxVisitor ||
                        prevEdit.visitDuration !== editData.visitDuration
                    );
                    const plansAffected = prevPlans && (
                        JSON.stringify(prevPlans) !== JSON.stringify(plans)
                    );
                    const hasExistingSpots = existingSpotsData.some(
                        s => s?.spotdaystartend?.length > 0 || s?.spotdayplanstartend?.length > 0
                    );
                    if ((hoursAffected || plansAffected) && hasExistingSpots) {
                        setShowHoursUpdateWarning(true);
                    }

                    getStore();
                    setIsServerSync(true);
                    // navigate("/spotsmanage/" + id);
                }
            }
        } catch (error) {
            console.error("Error updating store:", error);
            setAlertConfig({
                title: "Error",
                type: "error",
                message: error.response?.data?.message || "Something went wrong",
            });
            setShowAlert(true);
        }

        //setLoaderEnable(false);
    };

    console.log('editdata', editData)
    const validatePreferences = () => {
        let newErrors = {};

        // ✅ Validate Main Preferences
        const requiredFields = [
            "maxVisitor",
            "visitDuration",
            // "codeExpiration",
            "maxPartySize",
            "automatedExit",
            "maxLocationCapacity",
            "maxFutureDays",
            "earlyCheckInWindow"
        ];

        requiredFields.forEach((field) => {
            if (editData[field] === undefined || editData[field] === null || editData[field] === "" || editData[field] === "0" || editData[field] === 0) {
                newErrors[field] = `${capitalizeFirstLetter(field)} is required`;
            } else {
                delete newErrors[field];
            }
        });


        // ✅ Check if at least one plan is filled
        const plansArray = ["basicPlan", "premiumPlan", "vipPlan"];

        plansArray.forEach((planKey) => {
            const plan = plans[planKey];
            if (!plan?.active) return; // Skip validation if plan is inactive

            // ✅ Allow price "0" for Basic Plan
            if (!plan?.price?.trim()) {
                newErrors[`${planKey}_price`] = "Price is required";
            } else if (
                isNaN(plan?.price) ||
                (Number(plan?.price) <= 0 && planKey !== "basicPlan") // Allow 0 only for Basic Plan
            ) {
                newErrors[`${planKey}_price`] = "Enter a valid price";
            } else {
                delete newErrors[`${planKey}_price`];
            }

            // A price above $0 is only collectable through the client's own
            // connected Stripe account - without one there's nothing to route the
            // booking payment to, and the split would have to be settled by hand.
            // Free plans ($0 Basic) are unaffected, so a client with no bank
            // account can still run the location.
            if (canTakePaid === false && Number(plan?.price) > 0 && !newErrors[`${planKey}_price`]) {
                newErrors[`${planKey}_price`] = paidPaused
                    ? "Paid bookings are paused on your Stripe account - see your Business Profile."
                    : "Connect your bank account to charge for this plan.";
            }

            if (!plan?.benefits?.[0]?.trim()) {
                newErrors[`${planKey}_benefit_0`] = "At least one benefit is required.";
            } else {
                delete newErrors[`${planKey}_benefit_0`];
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // console.log("percentageValue plans", percentageValue, tempValue)
    let imageCloudFront = window?.site?.common?.imageCloudfront

    // Distribute maxVisitor slots across active plans using Largest Remainder Method
    // so the sum always equals exactly maxVisitor (no over/under due to rounding).
    const visitorAllocations = (() => {
        const maxVisitor = parseInt(editData?.maxVisitor || 0);
        const allocs = {};
        const fracs = [];
        Object.keys(plans || {}).forEach(k => {
            const p = plans[k];
            if (!p?.active) { allocs[k] = 0; return; }
            const exact = (p.percentage / 100) * maxVisitor;
            allocs[k] = Math.floor(exact);
            fracs.push({ key: k, frac: exact - Math.floor(exact) });
        });
        let rem = maxVisitor - Object.values(allocs).reduce((s, v) => s + v, 0);
        fracs.sort((a, b) => b.frac - a.frac);
        for (let i = 0; i < rem && i < fracs.length; i++) allocs[fracs[i].key]++;
        return allocs;
    })();

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            {image && !isRefreshed ? <>  <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <Modal className="access-denied" show={showDiscardModal} centered>
                    <div className="modal-body enquiry-form">
                        <div className="container">
                            <button
                                className="close-btn"
                                onClick={() => {
                                    setShowDiscardModal(false);
                                    setPendingAction(null);
                                }}
                            >
                                <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                                warning
                            </span>

                            <h3>Unsaved Changes</h3>
                            <p>
                                You have unsaved changes.<br />
                                Do you want to discard them or continue editing?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                                <button
                                    className="fill_btn"
                                    onClick={handleDiscardChanges}
                                >
                                    Discard
                                </button>

                                <button
                                    className="fill_btn yellow-gradient"
                                    onClick={() => {
                                        setShowDiscardModal(false);
                                        setPendingAction(null);
                                    }}
                                >
                                    Continue Editing
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <div className="main-content user-management">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* Breadcrumb */}
                            <div className="row mb-4 breadcrumb" id="breadcrumb-location-management">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="page-title-location-management">Location management</h4>
                                            <p className="menu-path">
                                                <span>Location management</span> / <b>{add === true ? "Create" : "EDIT"}</b>

                                            </p>
                                        </div>
                                        <div>
                                            <button className="stroke-btn-style" id="back-button3" onClick={handleBack}>
                                                <span className="material-symbols-outlined" id="back-icon2">arrow_back</span>Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {showBankReminder && (
                                <div className="row" id="addstore-bank-reminder-row">
                                    <div className="col-12">
                                        <div
                                            id="addstore-bank-reminder"
                                            style={{
                                                background: '#fefce8',
                                                border: '1px solid #ca8a04',
                                                borderRadius: '10px',
                                                padding: '14px 18px',
                                                marginBottom: '18px',
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '12px'
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ color: '#ca8a04', fontSize: '24px' }} aria-hidden="true">account_balance</span>
                                            <div style={{ flex: 1 }}>
                                                <h5 style={{ margin: 0, color: '#854d0e', fontWeight: 700, fontSize: '15px' }} id="addstore-bank-reminder-title">
                                                    Your bank account isn't connected yet
                                                </h5>
                                                <p style={{ margin: '4px 0 12px', color: '#854d0e', fontSize: '13.5px' }} id="addstore-bank-reminder-text">
                                                    You can set up this location now, but bookings can't be paid out until Stripe has your bank details.
                                                </p>
                                                <button
                                                    type="button"
                                                    className="fill-btn"
                                                    style={{ background: '#ca8a04', borderColor: '#ca8a04' }}
                                                    onClick={() => navigate("/connectbankaccount", { state: { nextRoute: "/addstore" } })}
                                                    id="addstore-bank-reminder-link"
                                                >
                                                    Connect it now
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Form Content */}
                            <div className="row table-data">
                                <div className="col-12">

                                    <div className="card" >
                                        <div className="card-body edit-store" >
                                            <ul className="nav nav-tabs nav-tabs-custom" role="tablist" id="edit-stores-tab-navigation">
                                                <li className="nav-item" role="presentation" onClick={() => handleTabSwitch("location")} id="tab-location-info" style={{ cursor: "pointer" }}>
                                                    <a
                                                        className={`nav-link ${locationStatus ? "active" : ""}`}
                                                        role="tab"
                                                        aria-selected={locationStatus}
                                                        id="location-info-tab"
                                                    >
                                                        <span className="material-symbols-outlined">package_2</span>
                                                        <span className="d-none d-sm-block">Location info</span>
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation" onClick={() => handleTabSwitch("preferences")} id="tab-preferences" style={{ cursor: "pointer" }}>
                                                    <a
                                                        className={`nav-link ${preferenceStatus ? "active" : ""}`}
                                                        role="tab"
                                                        aria-selected={preferenceStatus}
                                                        id="preferences-tab"
                                                    >
                                                        <span className="material-symbols-outlined">tune</span>
                                                        <span className="d-none d-sm-block">PREFERENCES</span>
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation" onClick={() => handleTabSwitch("spots")} id="tab-preferences" style={{ cursor: "pointer" }}>
                                                    <a
                                                        className={`nav-link ${spotsStatus ? "active" : ""}`}
                                                        role="tab"
                                                        aria-selected={spotsStatus}
                                                        id="spots-tab"
                                                    >
                                                        <span className="material-symbols-outlined">calendar_month</span>
                                                        <span className="d-none d-sm-block">SPOTS</span>
                                                    </a>
                                                </li>
                                            </ul>
                                            {!spotsStatus && <div className="note" id="store-hidden-message">
                                                Your store will remain hidden from visitors until regular hours are set
                                            </div>}
                                            
                                                <div className="tab-content p-3 text-muted">
                                                    {locationStatus &&
                                                        <div className="tab-pane active show" id="home1" role="tabpanel">

                                                            <div className="row location-info">

                                                                <div className="col-md-6 right-section">


                                                                    <div className="input_group_wrapper">
                                                                        <label className="form_label">LOCATION NAME <span className="required">*</span></label>
                                                                        <div className="input_group">
                                                                            <div className="icon_wrapper">
                                                                                <span className="material-symbols-outlined">storefront</span>
                                                                            </div>
                                                                            <input type="text"
                                                                                className={`form-control`}
                                                                                id="location-name-input"
                                                                                name="name"
                                                                                value={formData?.name}
                                                                                onChange={handleChange}
                                                                                placeholder="Enter Location Name"
                                                                            />
                                                                        </div>

                                                                        {errors.name && <span className="errormsg" style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'red',
                                                                        }}>{errors.name}</span>}
                                                                    </div>


                                                                    <div className="input_group_wrapper mt-3">
                                                                        <label className="form_label">LOCATION CATEGORY<span className="required">*</span></label>
                                                                        <div className="input_group">
                                                                            <div className="icon_wrapper">
                                                                                <span className="material-symbols-outlined">store</span>
                                                                            </div>
                                                                            <select
                                                                                className="form-select form-control"
                                                                                id="category-select"
                                                                                name="category"
                                                                                value={formData?.category}
                                                                                onChange={handleChange}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <option value="" id="category-option-default">Select Category</option>
                                                                                {data?.map((item) => {
                                                                                    const optionId = `category-${item?.name?.toLowerCase().replace(/\s+/g, '-')}`; // sanitize for spaces/special chars
                                                                                    return (
                                                                                        <option
                                                                                            key={item?.name}
                                                                                            value={item?.name}
                                                                                            id={optionId}
                                                                                        >
                                                                                            {item?.name}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                            </select>

                                                                        </div>
                                                                        {errors.category && <span className="errormsg" style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'red',
                                                                        }}>{errors.category}</span>}
                                                                    </div>

                                                                    <label className="form_label mt-3" htmlFor="phone-input" id="phone-label">LOCATION PHONE NUMBER<span className="required">*</span></label>
                                                                    <div className="input-group mr-sm-2" id="phone-group">

                                                                        <select
                                                                            name="idc"
                                                                            className="colorselect capitalize border-style"
                                                                            onChange={handleCountryChange}
                                                                            value={formData?.idc || ""}

                                                                        >
                                                                            <option value="">Select</option>
                                                                            {countries?.length > 0 && countries.map((task, i) => {
                                                                                const formattedValue = `${task.alpha3.trim()}${task.countrycode.trim()}`;
                                                                                return (
                                                                                    <option key={i} value={formattedValue}>
                                                                                        {formattedValue}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>

                                                                        <input
                                                                            type="text"
                                                                            className={`form-control`}
                                                                            id="phone-input"
                                                                            name="phone"
                                                                            value={formData?.phone}
                                                                            onChange={handleChange}
                                                                            placeholder="Enter Phone Number"

                                                                        />

                                                                    </div>
                                                                    {errors.phone && <span className="errormsg" style={{
                                                                        fontWeight: 'bold',
                                                                        color: 'red',

                                                                    }}>{errors.phone}</span>}

                                                                    <div className="input_group_wrapper mt-2">
                                                                        <label className="form_label">STATUS<span className="required">*</span></label>
                                                                        <div className="input_group">
                                                                            <div className="icon_wrapper">
                                                                                <span className="material-symbols-outlined text-success">check_circle</span>

                                                                            </div>
                                                                            <select
                                                                                className="form-select form-control"
                                                                                id="status-select"
                                                                                name="status"
                                                                                value={formData?.status}
                                                                                onChange={handleChange}
                                                                                style={{ cursor: "pointer" }}
                                                                            >
                                                                                <option value="" id="status-option-default">Select Status</option>
                                                                                <option value="ACTIVE" id="status-option-active" disabled={!formData?.spots}>ACTIVE</option>
                                                                                <option value="INACTIVE" id="status-option-inactive">INACTIVE</option>


                                                                            </select>
                                                                        </div>
                                                                        {!formData?.spots && (
                                                                            <span className="errormsg" style={{
                                                                                fontWeight: 'normal',
                                                                                color: '#888',
                                                                            }}>Add spot hours to activate this location.</span>
                                                                        )}
                                                                        {errors.status && <span className="errormsg" style={{
                                                                            fontWeight: 'bold',
                                                                            color: 'red',
                                                                        }}>{errors.status}</span>}
                                                                    </div>

                                                                    <label className="form_label mt-3" for="phone-input" id="upload-logo-label">UPLOAD LOCATION LOGO<span style={{ textTransform: "lowercase" }}></span><span className="required">*</span></label>
                                                                    <div className="d-flex upload_images" id="upload-images-section">
                                                                        {formData?.logo?.length > 0 ? (
                                                                            <div className="thumbnail-pic location-imgs" id="thumbnail-container">
                                                                                <span
                                                                                    className="material-symbols-outlined thumbnail-cls-icon"
                                                                                    id="remove-logo-btn"
                                                                                    onClick={e => handleRemove()}
                                                                                    onKeyDown={keyActivate(e => handleRemove())}
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    close
                                                                                </span>

                                                                                <img
                                                                                    src={
                                                                                        formData?.logo?.[0]?.filepath?.startsWith("blob:")
                                                                                            ? formData?.logo[0]?.filepath
                                                                                            : imageCloudFront + formData?.logo?.[0]?.filepath
                                                                                    }
                                                                                    id="active-image"
                                                                                    alt="Uploaded Logo"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                <div id="logo-upload-container" className="add_block">
                                                                                    <input
                                                                                        type="file"
                                                                                        id="location-logo"
                                                                                        accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                                        className="d-none"
                                                                                        multiple={false}
                                                                                        onChange={handleFileChange}
                                                                                        style={{ display: 'none' }}
                                                                                    />

                                                                                    <label
                                                                                        htmlFor="location-logo"
                                                                                        id="upload-logo-label"
                                                                                        style={{ display: "contents" }}
                                                                                    >
                                                                                        <span className="material-symbols-outlined" id="upload-icon">add</span>
                                                                                        <span>ADD</span>
                                                                                    </label>
                                                                                </div>

                                                                                <div className="file_requirements" id="file-requirements">
                                                                                    <p id="max-file-size">Maximum file size: 5MB</p>
                                                                                    <p id="supported-formats">Supported formats: JPG, PNG, HEIC</p>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>

                                                                    {errors.logo && <span className="errormsg" style={{
                                                                        fontWeight: 'bold',
                                                                        color: 'red',

                                                                    }}>{errors.logo}</span>}



                                                                    <div className="mb-3" id="store-images-section">
                                                                        <label className="form_label mt-3" id="upload-store-images-label">UPLOAD LOCATION IMAGES<span style={{ textTransform: "lowercase" }}>(OPTIONAL)</span></label>
                                                                        <div className="d-flex upload_images mb-3" id="store-upload-container">

                                                                            {storeFiles?.length > 0 && storeFiles?.map((item, index) => (
                                                                                <div key={index} className="thumbnail-pic" id={`uploaded-store-image-${index}`}>
                                                                                    <span
                                                                                        className="material-symbols-outlined thumbnail-cls-icon"
                                                                                        id={`delete-store-image-${index}`}
                                                                                        onClick={(e) => deleteclick(item, index)}
                                                                                        onKeyDown={keyActivate((e) => deleteclick(item, index))}
                                                                                    >
                                                                                        close
                                                                                    </span>
                                                                                    <img
                                                                                        src={item?.image}
                                                                                        alt={`StoreImage ${index + 1}`}
                                                                                        id={`store-image-preview-${index}`}
                                                                                    />
                                                                                </div>
                                                                            ))}

                                                                            {formData?.storeImages?.map((image, index) => (
                                                                                image?.filepath && (
                                                                                    <div key={index} className="thumbnail-pic" id={`existing-store-image-${index}`}>
                                                                                        <span
                                                                                            className="material-symbols-outlined thumbnail-cls-icon"
                                                                                            id={`delete-existing-image-${index}`}
                                                                                            onClick={(e) => deleteclick(image, index)}
                                                                                            onKeyDown={keyActivate((e) => deleteclick(image, index))}
                                                                                        >
                                                                                            close
                                                                                        </span>
                                                                                        <img
                                                                                            src={imageCloudFront + image?.filepath}
                                                                                            alt={`Store ${index + 1}`}
                                                                                            id={`store-existing-image-preview-${index}`}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            ))}

                                                                            <div className="add_block" id="add-store-image-section">
                                                                                <input
                                                                                    type="file"
                                                                                    id="store-file-upload"
                                                                                    accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                                    className="d-none"
                                                                                    multiple={true}
                                                                                    onChange={e => handleStoreImageUpload(e)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                <label
                                                                                    htmlFor="store-file-upload"
                                                                                    className="Add-Icon"
                                                                                    id="add-store-image-btn"
                                                                                >
                                                                                    <span className="material-symbols-outlined">add</span>
                                                                                    <span>ADD</span>
                                                                                </label>
                                                                            </div>

                                                                            <div className="file_requirements" id="store-file-requirements">
                                                                                <p id="store-max-file-size">Maximum file size: 5MB</p>
                                                                                <p id="store-supported-formats">Supported formats: JPG, PNG, HEIC</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                </div>


                                                                {/* Map Section */}
                                                                <div className="col-md-6" id="map-section">
                                                                    <label className="form_label" htmlFor="html">LOCATION ADDRESS<span className="required">*</span></label>
                                                                    <div className="input-group mb-2 mr-sm-2" id="address-input-group">

                                                                    </div>

                                                                    {errors.address && <span className="errormsg" style={{
                                                                        fontWeight: 'bold',
                                                                        color: 'red',
                                                                        position: "absolute",
                                                                        top: "68px"
                                                                    }}>{errors.address}</span>}
                                                                    <div className="map_block" id="map-block">
                                                                        {mapsAPIkey !== false && formData && (
                                                                            <LocationSearch
                                                                                id="location-search"
                                                                                setSelectedPlace={null}
                                                                                setAddressData={(data) => {
                                                                                    setAddressData(data);
                                                                                    handleAddressChange(data);
                                                                                }}
                                                                                mapVisible={true}
                                                                                formData={mapaddress}
                                                                                mapsAPIkey={mapsAPIkey}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                        )}


                                                                    </div>

                                                                    {/* Submit Button */}
                                                                    <div>
                                                                        {updateFlagValue == true ?
                                                                            <button
                                                                                disabled={loaderEnable}
                                                                                onClick={handleSubmit}
                                                                                className="fill-btn save_continue mt-3"
                                                                                id={locationFlag === false ? "save-and-continue-button" : "update-and-continue-button"}
                                                                                style={{ cursor: "pointer" }}

                                                                            //disabled={isSaveDisabled}
                                                                            >
                                                                                {loaderEnable ? (
                                                                                    <img
                                                                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                                                                        className="loading-icon"
                                                                                    />
                                                                                ) : null}
                                                                                {locationFlag === false ? "Save & Continue" : "Update & Continue"}
                                                                            </button> :
                                                                            <button
                                                                                onClick={handleSubmit}
                                                                                className="fill-btn save_continue mt-3"
                                                                                id={locationFlag === false ? "save-and-continue-button" : "update-and-continue-button"}
                                                                                style={{ cursor: "not-allowed" }}
                                                                                disabled
                                                                            //disabled={isSaveDisabled}
                                                                            >
                                                                                {loaderEnable ? (
                                                                                    <img
                                                                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                                                                        className="loading-icon"
                                                                                    />
                                                                                ) : null}
                                                                                {locationFlag === false ? "Save & Continue" : "Update & Continue"}
                                                                            </button>}


                                                                    </div>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    }
                                                    {preferenceStatus &&
                                                        <div className="" id="profile1" role="tabpanel">
                                                            {/* here */}
                                                            <h4 className="form-title">PREFERENCES</h4>
                                                            <div className="row preferences-tab preference-top-section">
                                                                {preferenceFields?.[0]?.map(({ label, name, min, max, unit = "", helperText }) => {
                                                                    let dynamicMax = max;
                                                                    if (name === "maxVisitor") {
                                                                        const locationCap = parseInt(editData?.maxLocationCapacity || 0);
                                                                        if (!isNaN(locationCap) && locationCap > 0) {
                                                                            dynamicMax = Math.min(locationCap, 100);
                                                                        }
                                                                        // console.log("locationCap", locationCap);
                                                                        // console.log("dynamicMax", dynamicMax);
                                                                    }
                                                                    return (
                                                                        <div className="col-md-4" key={name}>
                                                                            <div className="store_block">
                                                                                <div className="Range-box-section">
                                                                                    <h3 className="Range-title" id={`range-${name}`} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                                        {label}
                                                                                        {helperText && (
                                                                                            <Tooltip title={helperText} arrow placement="top">
                                                                                                <InfoOutlinedIcon style={{ fontSize: "16px", color: "#888", cursor: "pointer" }} />
                                                                                            </Tooltip>
                                                                                        )}
                                                                                    </h3>

                                                                                    <div className="input-group mt-2">
                                                                                        <input
                                                                                            id={`preference-${name}`}  // Added unique id here
                                                                                            className="form-control form-left-border"
                                                                                            type="number"
                                                                                            name={name}
                                                                                            value={editData?.[name] ?? min}
                                                                                            onChange={preferenceChange}
                                                                                            min={min}
                                                                                            max={dynamicMax}
                                                                                            onFocus={(e) => {
                                                                                                if (e.target.value === '0') {
                                                                                                    e.target.value = '';
                                                                                                    setEditData((prev) => ({
                                                                                                        ...prev,
                                                                                                        [e.target.name]: '',
                                                                                                    }));
                                                                                                    setFormData((prev) => ({
                                                                                                        ...prev,
                                                                                                        [e.target.name]: '',
                                                                                                    }));
                                                                                                }
                                                                                            }}
                                                                                            onBlur={(e) => {
                                                                                                if (e.target.value === '') {
                                                                                                    setEditData((prev) => ({
                                                                                                        ...prev,
                                                                                                        [e.target.name]: 0,
                                                                                                    }));
                                                                                                    setFormData((prev) => ({
                                                                                                        ...prev,
                                                                                                        [e.target.name]: 0,
                                                                                                    }));
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        <div className="unit">{dynamicMax}{unit}</div>
                                                                                    </div>

                                                                                    {errors?.[name] && (
                                                                                        <span className="error" style={{ position: "absolute" }}>
                                                                                            {errors[name]}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>

                                                            <div className="nav-tabs mt-2"></div>

                                                            <h4 className="form-title mt-4">PLAN SETTINGS</h4>
                                                            {canTakePaid === false && (
                                                                <div
                                                                    id="plan-settings-bank-gate"
                                                                    style={{
                                                                        background: '#fefce8',
                                                                        border: '1px solid #ca8a04',
                                                                        borderRadius: '10px',
                                                                        padding: '12px 16px',
                                                                        margin: '10px 0 4px',
                                                                        display: 'flex',
                                                                        alignItems: 'flex-start',
                                                                        gap: '12px'
                                                                    }}
                                                                >
                                                                    <span className="material-symbols-outlined" style={{ color: '#ca8a04', fontSize: '22px' }} aria-hidden="true">account_balance</span>
                                                                    <div style={{ flex: 1 }}>
                                                                        <p style={{ margin: 0, color: '#854d0e', fontSize: '13.5px' }} id="plan-settings-bank-gate-text">
                                                                            {paidPaused
                                                                                ? "Stripe has paused transfers to your account, so paid plans can't be booked right now - customers only see your free ($0) plans. Your Business Profile shows what Stripe needs."
                                                                                : "Paid plans need a connected bank account - we can't collect a booking payment with nowhere to send it. You can save free ($0) plans in the meantime."}
                                                                        </p>
                                                                        <button
                                                                            type="button"
                                                                            className="fill-btn"
                                                                            style={{ background: '#ca8a04', borderColor: '#ca8a04', marginTop: '10px' }}
                                                                            onClick={() => guardUnsavedChanges(() => (paidPaused
                                                                                ? navigate("/businessprofile")
                                                                                : navigate("/connectbankaccount", { state: { nextRoute: id ? `/editstore/${id}` : "/addstore" } })))}
                                                                            id="plan-settings-bank-gate-link"
                                                                        >
                                                                            {paidPaused ? "Open Business Profile" : "Connect bank account"}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div className="row preferences-tab preference-bottom-section">
                                                                {plans && Object.keys(plans || {})?.map((key) => {
                                                                    let plan = plans[key];
                                                                    const isSaveDisabled = !plan?.active;
                                                                    const showPriceError = errors[`${key}_price`]; // Checks if price has error
                                                                    const showBenefitError = plan?.showErrors && plan?.benefits[0]?.trim() === "";
                                                                    // const locationCap = parseInt(editData?.maxLocationCapacity || 0);
                                                                    const locationCap = parseInt(editData?.maxVisitor || 0);
                                                                    const minPrice = 0;  // Minimum price value
                                                                    const maxPrice = 100;
                                                                    return (
                                                                        <div key={plan?.id} className="col-md-4">
                                                                            <div className="store_block plan-page">
                                                                                {/* HEADER */}
                                                                                <div className="d-flex justify-content-between line align-items-center">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <h3 className="sm-heading">{plan?.name} Plan</h3>
                                                                                        <h3 className={`${plan?.name?.toLowerCase()}-badge-style`}>
                                                                                            <span className="material-symbols-outlined">local_activity</span>
                                                                                            {plan?.name}
                                                                                        </h3>
                                                                                    </div>

                                                                                    {/* ACTIVE TOGGLE */}
                                                                                    <div className="input-field switch-buttons d-flex align-items-center">
                                                                                        <label className="col-form-label p-0 me-2" htmlFor={`active-toggle-${plan?.id}`}>Active</label>
                                                                                        <label className="switch disable mb-0">
                                                                                            <input
                                                                                                id={`active-toggle-${plan?.id}`}
                                                                                                type="checkbox"
                                                                                                checked={plan?.active}
                                                                                                onChange={(e) => toggleActive(plan?.id, key, e)}
                                                                                            />
                                                                                            <span className="slider round"></span>
                                                                                        </label>
                                                                                    </div>
                                                                                </div>



                                                                                {/* Percentage section */}
                                                                                <div className="mt-2 mb-2">
                                                                                    {/* Top row: label left, value+% right */}
                                                                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                                                                        <label
                                                                                            className="sm-heading mb-0"
                                                                                            htmlFor={`percentage-${key}`}
                                                                                        >
                                                                                            Percentage
                                                                                        </label>
                                                                                        <div className="input-group input-group-sm" style={{ width: "80px" }}>
                                                                                            <input
                                                                                                id={`percentage-manual-${key}`}
                                                                                                className="form-control text-center"
                                                                                                type="number"
                                                                                                name="percentage"
                                                                                                min={minPrice}
                                                                                                max={maxPrice}
                                                                                                value={plan?.percentage}
                                                                                                disabled={!plan?.active}
                                                                                                onChange={(e) => handlePercentageChange(e, plan?.id, key)}
                                                                                            />
                                                                                            <span className="input-group-text px-2">%</span>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Full-width slider */}
                                                                                    <input
                                                                                        id={`percentage-${key}`}
                                                                                        className="range-style"
                                                                                        type="range"
                                                                                        name="percentage"
                                                                                        min={minPrice}
                                                                                        max={maxPrice}
                                                                                        step="1"
                                                                                        value={plan?.percentage || minPrice}
                                                                                        disabled={!plan?.active}
                                                                                        onChange={(e) => handlePercentageChange(e, plan?.id, key)}
                                                                                        style={{ width: "100%" }}
                                                                                    />

                                                                                    {/* Bottom row: 0 left, Max/Slot centre-right, 100 right */}
                                                                                    <div className="d-flex align-items-center justify-content-between mt-1">
                                                                                        <span className="text-muted" style={{ fontSize: "11px" }}>0</span>
                                                                                        <div className="d-flex align-items-center gap-1">
                                                                                            <span className="text-muted" style={{ fontSize: "11px" }}>Max Visitors / Slot</span>
                                                                                            <span
                                                                                                className="badge rounded-pill"
                                                                                                style={{ background: "#ede9fe", color: "#6d28d9", fontSize: "12px", fontWeight: 600, padding: "2px 9px" }}
                                                                                            >
                                                                                                {visitorAllocations[key] ?? 0}
                                                                                            </span>
                                                                                        </div>
                                                                                        <span className="text-muted" style={{ fontSize: "11px" }}>100</span>
                                                                                    </div>
                                                                                </div>

                                                                                {plan?.active && errors.percentage && (
                                                                                    <span className="errormsg">{errors.percentage}</span>
                                                                                )}

                                                                                {/* PRICE INPUT */}
                                                                                <div className="input-group mb-2 mr-sm-2">
                                                                                    <input
                                                                                        id={`price-${plan?.id}`}
                                                                                        className={`form-control ${errors[`${plan?.id}_price`] ? "is-invalid" : ""}`}
                                                                                        placeholder="Enter Price *"
                                                                                        type="text"
                                                                                        value={plan?.price || ""}
                                                                                        disabled={!plan?.active}
                                                                                        onChange={(e) => handlePlansChange(plan?.id, "price", e.target.value)}
                                                                                        onKeyDown={(e) => {
                                                                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                                                                                e.preventDefault();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    <div className="input-group-prepend">
                                                                                        <div className="input-group-text">
                                                                                            <span className="material-symbols-outlined">attach_money</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {showPriceError && <span className="text-danger">{errors[`${key}_price`]}</span>}

                                                                                {/* BENEFITS HEADER */}
                                                                                <div className="d-flex justify-content-between line align-items-center mt-3">
                                                                                    <h3 className="sm-heading">What do you get?</h3>
                                                                                </div>

                                                                                {/* BENEFIT FIELDS */}
                                                                                {plan?.benefits?.map((benefit, index) => {
                                                                                    const showBenefitFieldError = errors[`${key}_benefit_${index}`]; // Check for individual benefit errors
                                                                                    return (
                                                                                        <div className="input-group mb-2 mr-sm-2" key={index}>
                                                                                            <input
                                                                                                id={`benefit-${key}-${index}`}
                                                                                                className={`form-control ${showBenefitFieldError ? "is-invalid" : ""}`}
                                                                                                placeholder={index === 0 ? "Enter * (Required)" : "Enter"}
                                                                                                type="text"
                                                                                                value={plan?.benefits[index]}
                                                                                                disabled={!plan?.active}
                                                                                                onChange={(e) =>
                                                                                                    handlePlansChange(plan?.id, `benefit_${index}`, e.target.value, index)
                                                                                                }
                                                                                            />
                                                                                            {showBenefitFieldError && (
                                                                                                <small className="text-danger">{errors[`${key}_benefit_${index}`]}</small>
                                                                                            )}

                                                                                            {/* Delete Button */}
                                                                                            <div className="input-group-prepend">
                                                                                                <div
                                                                                                    className="input-group-text"
                                                                                                    onClick={() =>
                                                                                                        handlePlansChange(plan?.id, `benefit_${index}`, "", index)
                                                                                                    }
                                                                                                    onKeyDown={keyActivate(() =>
                                                                                                        handlePlansChange(plan?.id, `benefit_${index}`, "", index)
                                                                                                    )}
                                                                                                >
                                                                                                    <span className="material-symbols-outlined">delete</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                })}

                                                                                {/* You can add the Save button here if needed */}

                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                                {preferenceError && (
                                                                    <div className="d-flex align-items-center gap-2 flex-wrap mt-1">
                                                                        <small className="errormsg">{preferenceError}</small>
                                                                        <button
                                                                            type="button"
                                                                            className="fill-btn-style"
                                                                            style={{ fontSize: 12, padding: '4px 12px', whiteSpace: 'nowrap' }}
                                                                            onClick={() => handleTabSwitch("spots")}
                                                                        >
                                                                            Go to Spots
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-md-12 text-right mt-3">
                                                                {updateFlagValue === false ? (
                                                                    <button
                                                                        className="fill-btn-style"
                                                                        disabled
                                                                        onClick={handleSave}
                                                                        style={{ cursor: "not-allowed" }}
                                                                        id="preferences-submit-button"
                                                                    >
                                                                        {loaderEnable && (
                                                                            <img
                                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                                className="loading-icon"
                                                                                alt="Loading"
                                                                            />
                                                                        )}
                                                                        UPDATE
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="fill-btn-style"
                                                                        disabled={loaderEnable}
                                                                        onClick={handleSave}
                                                                        style={{ cursor: "pointer" }}
                                                                        id="preferences-submit-button"
                                                                    >
                                                                        {loaderEnable && (
                                                                            <img
                                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                                className="loading-icon"
                                                                                alt="Loading"
                                                                            />
                                                                        )}
                                                                        Update & continue
                                                                    </button>
                                                                )}
                                                            </div>


                                                        </div>}

                                                    {spotsStatus &&
                                                            <SpotsManageCore
                                                                storeId={id}
                                                                embedded={true}
                                                                onEditPreferences={() => {
                                                                    setLocationStatus(false);
                                                                    setSpotsStatus(false);
                                                                    setPreferenceStatus(true);
                                                                }}
                                                                autoOpenEditHours={autoOpenEditHours}
                                                                onAutoOpenDone={() => setAutoOpenEditHours(false)}
                                                            />
                                                        }
                                                </div>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    {/* Hours Update Warning Modal */}
                    <Modal className="access-denied" show={showHoursUpdateWarning} centered>
                        <div className="modal-body enquiry-form">
                            <div className="container">
                                <span className="material-symbols-outlined access-denied-icon" style={{ color: '#f59e0b' }}>
                                    warning
                                </span>
                                <h3>Spot Hours Updated</h3>
                                <p>
                                    Your existing plan hours have been automatically updated to reflect your new preference settings (Max Visitors / Slot or Plan Settings).
                                    <br /><br />
                                    Click below to review the changes on the <strong>Spots</strong> tab and make any further adjustments if needed.
                                </p>
                                <div className="popup-footer d-flex gap-2">
                                    <button
                                        className="fill_btn yellow-gradient"
                                        onClick={() => {
                                            setShowHoursUpdateWarning(false);
                                            setLocationStatus(false);
                                            setPreferenceStatus(false);
                                            setSpotsStatus(true);
                                            setAutoOpenEditHours(true);
                                        }}
                                    >
                                        Go to Spots &amp; Edit Hours
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal className="access-denied" show={showDeleteAlert} >

                        <div className="modal-body enquiry-form">
                            <div className="container">
                                <button className="close-btn" onClick={e => handleClose()}><span className="material-icons">close</span></button>
                                {/* <span className="material-icons access-denied-icon">https</span> */}
                                <span className="material-icons access-denied-icon">delete_outline</span>
                                <h3>Delete</h3>
                                <p>Are you sure you want to delete this logo.</p>
                                <div className="popup-footer">
                                    <button
                                        disabled={deleteLoader}
                                        className="fill-btn mt-3"
                                        type="button"
                                        onClick={handleDeleteClick}

                                    >
                                        {deleteLoader ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                alt="Loading"
                                            />
                                        ) : null}
                                        Yes
                                    </button>


                                </div>
                            </div>
                        </div>

                    </Modal>
                    <Modal className="access-denied" show={deletePopup} >

                        <div className="modal-body enquiry-form" id="delete-modal">
                            <div className="container" id="delete-modal-container">
                                <button className="close-btn" id="delete-modal-close" onClick={e => handleClose()}><span className="material-icons">close</span></button>
                                {/* <span className="material-icons access-denied-icon">https</span> */}
                                <span className="material-icons access-denied-icon" id="delete-modal-delete-icon">delete_outline</span>
                                <h3 id="delete-modal-title">Delete</h3>
                                <p id="delete-modal-description">Are you sure you want to delete this image.</p>
                                <div className="popup-footer" id="delete-modal-footer">
                                    <button
                                        className="fill-btn mt-3"
                                        type="button"
                                        id="delete-modal-confirm-button"
                                        onClick={deletePopupClick}
                                        disabled={deleteLoader}
                                    >
                                        {deleteLoader ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                id="delete-modal-loading-icon"
                                                alt="Loading"
                                            />
                                        ) : null}
                                        Yes
                                    </button>


                                </div>
                            </div>
                        </div>

                    </Modal>

                    {/* <SweetAlert show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                    >
                    </SweetAlert> */}
                    {/* <SweetAlert show={message}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={locationFlag === false ? "Location created successfully!" : "Location updated successfully!"}
                        onConfirm={e => { { setMessage(false) } }}
                    >
                    </SweetAlert> */}

                    <SweetAlert show={fileSizeError}
                        warning
                        confirmBtnText="ok"
                        confirmBtnBsStyle="danger"
                        title={"File size greater than 5MB"}
                        onConfirm={e => setFileSizeError(false)}
                    >
                    </SweetAlert>

                    <SweetAlert
                        show={showAlert}
                        title={alertConfig.title}
                        type={alertConfig.type}
                        onConfirm={() => setShowAlert(false)}
                    >
                        {alertConfig.message}
                    </SweetAlert>

                    <SweetAlert
                        show={showPlanHoursDeleteConfirm}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Delete Plan Hours?"
                        onConfirm={handleConfirmDeletePlanHours}
                        onCancel={() => setShowPlanHoursDeleteConfirm(false)}
                    >
                        Working hours for {planNamesToDelete.join(', ')} plan(s) will be deleted. Other plans' hours will remain. Do you want to continue?
                    </SweetAlert>

                    {/* <SweetAlert
                        show={showDeleteAlert}
                        title="Are you sure you want to delete this logo?"
                        showCancel
                        confirmBtnText="OK"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="primary"
                        cancelBtnBsStyle="danger"
                        onConfirm={handleDeleteClick} // Handle delete action
                        onCancel={() => setShowDeleteAlert(false)} // Close alert on cancel
                    /> */}
                    {/* <SweetAlert
                        show={deletePopup}
                        title="Are you sure you want to delete this Image?"
                        showCancel
                        confirmBtnText="OK"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="primary"
                        cancelBtnBsStyle="danger"
                        onConfirm={deletePopupClick} // Handle delete action
                        onCancel={() => setDeletePopup(false)} // Close alert on cancel
                    /> */}

                    <ToastContainer
                        id="toastContainer-location"
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                        style={{
                            bottom: "60px"   // 👈 value penchi/ thagginchi adjust cheyyi
                        }}
                    />

                    {/* Session Popup */}
                    {state?.showSessionPopup && <SessionPopup />}
                    <Footer />

                </div>



            </div> </> : <Loader />}

        </>
    );
};

export default EditStore;
